"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLicenseObservationDto = instanceOfLicenseObservationDto;
exports.LicenseObservationDtoFromJSON = LicenseObservationDtoFromJSON;
exports.LicenseObservationDtoFromJSONTyped = LicenseObservationDtoFromJSONTyped;
exports.LicenseObservationDtoToJSON = LicenseObservationDtoToJSON;
exports.LicenseObservationDtoToJSONTyped = LicenseObservationDtoToJSONTyped;
/**
 * Check if a given object implements the LicenseObservationDto interface.
 */
function instanceOfLicenseObservationDto(value) {
    if (!('jurisdiction' in value) || value['jurisdiction'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('licenseNumber' in value) || value['licenseNumber'] === undefined)
        return false;
    return true;
}
function LicenseObservationDtoFromJSON(json) {
    return LicenseObservationDtoFromJSONTyped(json, false);
}
function LicenseObservationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jurisdiction': json['jurisdiction'],
        'licenseType': json['licenseType'],
        'licenseNumber': json['licenseNumber'],
    };
}
function LicenseObservationDtoToJSON(json) {
    return LicenseObservationDtoToJSONTyped(json, false);
}
function LicenseObservationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jurisdiction': value['jurisdiction'],
        'licenseType': value['licenseType'],
        'licenseNumber': value['licenseNumber'],
    };
}
//# sourceMappingURL=LicenseObservationDto.js.map